export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT; // eslint-disable-line
export const ROUTING_PREFIX = process.env.REACT_APP_ROUTING_PREFIX;// eslint-disable-line
export const SECRET_PASSWORD = process.env.REACT_APP_SECRET_PASSWORD;// eslint-disable-line
export const SPLIT_CHANNEL = process.env.REACT_APP_SPLIT_CHANNEL;// eslint-disable-line

const localApiUrl = localStorage.getItem('api-url');
const hasValidLocalApiUrl = localApiUrl && localApiUrl !== 'undefined' && localApiUrl !== 'null';

export const API_URL = hasValidLocalApiUrl ? localApiUrl : process.env.REACT_APP_API_URL;// eslint-disable-line
export const APP_URL = process.env.REACT_APP_APP_URL;// eslint-disable-line
export const WEBSITE = process.env.REACT_APP_WEBSITE;// eslint-disable-line
export const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN;// eslint-disable-line
export const NOTIFICATIONS_SERVER_KEY = process.env.REACT_APP_NOTIFICATIONS_SERVER_KEY;// eslint-disable-line
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;// eslint-disable-line
export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;// eslint-disable-line
export const AI_AGENT_HOST = process.env.REACT_APP_AI_AGENT_HOST;// eslint-disable-line
export const SHOPIFY_INSTALL_URL = process.env.REACT_APP_SHOPIFY_INSTALL_URL;// eslint-disable-line
